import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { StorageService } from '../air/modules/common/service';
import { CommonService } from '../air/modules/common/service';
import { DirectLinkService } from '../air/modules/common/service/direct-link.service';
import { AuthService } from '../air/modules/common/service';
import { SpinnerVisibilityService } from "ng-http-loader";
import { SubSink } from 'subsink';
import { UserControlService } from '../air/modules/common/service/userControl/user-control.service';

@Component({
    selector: 'app-direct-link',
    templateUrl: './direct-link.component.html',
    styleUrls: ['./direct-link.component.scss'],
    standalone: false
})
export class DirectLinkComponent implements OnInit, OnDestroy {

  public requestParam: any = {};
  public guid: String;
  private encryptedText: string = 'encryptedText';
  private subscription = new SubSink();

  constructor(private directLinkService: DirectLinkService, private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    protected authService: AuthService,
    protected storageService: StorageService,
    protected userControlService: UserControlService,
    private spinner: SpinnerVisibilityService) {
    //Clear the token so that it should not redirect to login page for encrypted url
    //If opened in another tab of same browser.
  //  this.authService.setToken('');
  }

  ngOnInit(): void {

  }



  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
